// extracted by mini-css-extract-plugin
export default {"root":"A2toEWCl","progress":"PBoHbg_m","blue":"UtbbKQEQ","green":"RuhKPvOF","red":"tlOFCeRG","value":"zyklreXf"};